import type { State } from './state'

import state from './state'
import actionTypes from './actionTypes'
import actions from './actions'
import mutations from './mutations'

export { State, actionTypes }

export default {
    namespace: true,
    state,
    actions,
    mutations,
}
